export function TargetSmallBusinessIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="small-shop-alt">
      <path id="Rectangle" d="M4 13.3333V25.3333C4 26.8061 5.19391 28 6.66667 28H25.3333C26.8061 28 28 26.8061 28 25.3333V13.3333" stroke="currentColor" strokeWidth="2"/>
      <path id="Rectangle_2" d="M19.7786 28V20C19.7786 18.5272 18.5847 17.3333 17.112 17.3333H14.4453C12.9726 17.3333 11.7786 18.5272 11.7786 20V28" stroke="currentColor" strokeWidth="2" strokeMiterlimit="16"/>
      <path id="Rectangle 5" d="M29.0911 12.4856L26.8324 4.58022C26.7343 4.23678 26.4204 4 26.0632 4H20.6667L21.3004 11.605C21.3212 11.8539 21.4564 12.0787 21.671 12.2066C22.19 12.516 23.207 13.0893 24 13.3333C25.3543 13.7501 27.3345 13.5998 28.462 13.4611C28.9309 13.4034 29.2209 12.9399 29.0911 12.4856Z" stroke="currentColor" strokeWidth="2"/>
      <path id="Rectangle 4" d="M18.6667 13.3333C19.4233 13.1005 20.3839 12.5679 20.9213 12.2508C21.177 12.0998 21.3179 11.8147 21.2932 11.5187L20.6667 4H11.3333L10.7068 11.5187C10.6821 11.8147 10.823 12.0998 11.0788 12.2508C11.6161 12.5679 12.5767 13.1005 13.3333 13.3333C15.324 13.9459 16.676 13.9459 18.6667 13.3333Z" stroke="currentColor" strokeWidth="2"/>
      <path id="Rectangle 3" d="M5.16756 4.58022L2.90888 12.4856C2.77909 12.9399 3.06907 13.4034 3.53801 13.4611C4.66554 13.5998 6.64565 13.7501 8 13.3333C8.79303 13.0893 9.81002 12.516 10.329 12.2066C10.5436 12.0787 10.6788 11.8539 10.6996 11.605L11.3333 4H5.93677C5.57959 4 5.26568 4.23678 5.16756 4.58022Z" stroke="currentColor" strokeWidth="2"/>
      </g>
    </svg>
  )
}
